import { createApp } from 'vue';
import { createPinia } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import App from './App.vue';
import router from './router';
import { useClientStore } from './stores/client';
import { useServiceStore } from './stores/service';
import { useAppointmentStore } from './stores/appointment';
import { useReportDailyStore } from './stores/reportDaily';
import { useAppointmentRequestStore } from './stores/appointmentRequest';
import { useUserStore } from './stores/user';
import { useAvailableSlotsStore } from './stores/availableSlots';
import { usePaymentMethodStore } from './stores/paymentMethod';
import { useSupplyStore } from './stores/supply';
import { useBankAccountStore } from './stores/bankAccount';
import { useBankTransactionStore } from './stores/bankTransaction';
import { useTransactionCategoryStore } from './stores/transactionCategory';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from './firebase';

// global styles
import './assets/main.css';
import './registerServiceWorker';

const app = createApp(App);
const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);

app.use(pinia);
app.use(router);

const userStore = useUserStore(pinia);
const clientStore = useClientStore(pinia);
const serviceStore = useServiceStore(pinia);
const appointmentStore = useAppointmentStore(pinia);
const appointmentRequestStore = useAppointmentRequestStore(pinia);
const reportDailyStore = useReportDailyStore(pinia);
const availableSlotsStore = useAvailableSlotsStore(pinia);
const paymentMethodStore = usePaymentMethodStore(pinia);
const supplyStore = useSupplyStore(pinia);
const bankAccountStore = useBankAccountStore(pinia);
const bankTransactionStore = useBankTransactionStore(pinia);
const transactionCategoryStore = useTransactionCategoryStore(pinia);

const publicPaths = ['/', '/admin/entrar'];
const isPublicRoute = (path) => publicPaths.includes(path);

onAuthStateChanged(auth, async (user) => {
    userStore.setAuthIsReady(false);
    userStore.setUser(user);
    if (user) {
        await userStore.registerSnapshot();
        clientStore.registerSnapshot();
        serviceStore.registerSnapshot();
        paymentMethodStore.registerSnapshot();
        supplyStore.registerSnapshot();
        if (userStore.hasPermission('bankTransactions:manage')) {
          bankAccountStore.registerSnapshot();
          bankTransactionStore.registerSnapshot();
          transactionCategoryStore.registerSnapshot();
        } else {
          bankAccountStore.clear();
          bankTransactionStore.clear();
          transactionCategoryStore.clear();
        }
        appointmentStore.clearUnsubs();
        appointmentStore.registerMonthSnapshot(new Date());
        if (userStore.hasPermission('appointmentRequests:manage')) {
          appointmentRequestStore.registerSnapshot();
        } else {
          appointmentRequestStore.clear();
        }
        if (router.currentRoute.value.name === 'Login') {
            router.push('/admin/');
        }
    } else {
        userStore.clear();
        clientStore.clear();
        serviceStore.clear();
        paymentMethodStore.clear();
        supplyStore.clear();
        bankAccountStore.clear();
        bankTransactionStore.clear();
        transactionCategoryStore.clear();
        appointmentStore.clear();
        appointmentRequestStore.clear();
        reportDailyStore.clearReportDaily();
        if (!isPublicRoute(router.currentRoute.value.path)) {
            router.push('/admin/entrar');
        }
    }
    availableSlotsStore.registerSnapshot();
    userStore.setAuthIsReady(true);
});

router.beforeEach((to) => {
    /*if (!userStore.authIsReady) {
        if (isPublicRoute(to.path)) return;
        return { path: 'Login' };
    }*/
    if (!userStore.user) {
        if (isPublicRoute(to.path)) return;
        return { name: 'Login' };
    }
    if (userStore.user && to.name === 'Login') {
        return { name: 'Home' };
    }
    if (userStore.user) {
      const toName = to.name;
      if (toName === 'Services' && !userStore.hasPermission('services:manage')) {
        return { name: 'Home' };
      }
      if (toName === 'Report' && !userStore.hasPermission('reports:read')) {
        return { name: 'Home' };
      }
      if (toName === 'Providers' && !userStore.hasPermission('users:manage')) {
        return { name: 'Home' };
      }
      if (toName === 'Roles' && !userStore.hasPermission('roles:manage')) {
        return { name: 'Home' };
      }
      if (toName === 'PaymentMethods' && !userStore.hasPermission('paymentMethods:manage')) {
        return { name: 'Home' };
      }
      if (toName === 'Inventory' && !userStore.hasPermission('inventory:manage')) {
        return { name: 'Home' };
      }
      if (toName === 'Financeiro' && !userStore.hasPermission('bankTransactions:manage')) {
        return { name: 'Home' };
      }
      if (toName === 'Client' && !userStore.hasPermission('clients:manage') && !userStore.hasPermission('clients:create')) {
        return { name: 'Home' };
      }
    }
});

app.mount('#app');
